import { getDataListDetail } from '../../constants/api_index';

class episodeService {
  getEpisode(id) {
    return getDataListDetail('episode', id);
  }
}

export default new episodeService();
